<template>
  <validation-observer ref="simpleRules">
    <item-form />
  </validation-observer>
</template>

<script>

import { ValidationObserver, localize } from 'vee-validate'
import ItemForm from '@/views/Services/ItemForm.vue'

export default {
  name: 'Add',
  components: {
    ItemForm,
    ValidationObserver,
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
  },
  created() {
    localize('tr')
    this.$store.commit('services/RESET_DATA_ITEM')
  },
}
</script>
